import React, { useEffect, useState } from "react";
import useSignalR from "../../hub/useSignalR";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const NotificationPopup = () => {
    const message = useSignalR();
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (message || message != "") {
            setShow(true);
            setTimeout(() => setShow(false), 5000);
        }
    }, [message]);

    return show ? (
        <Popup trigger={<button> Trigger</button>} position="right center">
            <div>{message}</div>
        </Popup>
    ) : null;
};
export default NotificationPopup;